export class LinkFreeProtectionBillingRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsFreeProtectionBilling",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureFreeProtectionBilling",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpFreeProtectionBilling",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LinkFreeProtectionBillingRequest.attributeTypeMap;
    }
    constructor() {
    }
}
